<template>
    <whatapp />

    <footer class="bg-gray-900 text-gray-300">
        <div class="lg:container mx-auto px-4">
            <div class="footer-content">
                <!-- 左侧: Logo、公司简介和社交媒体 -->
                <div class="footer-left">
                    <img src="https://images.leaflypackaging.com/profile/upload/2026/01/29/leafly-logo-white_20260129165658A008.webp" alt="Leafly Packaging" class="footer-logo" />
                    <p class="footer-desc">Leaflypackaging Tech has always insisted on providing one-stop CBD vape and cannabis packaging solutions for brands and distributors, high-quality cartridges and disposable pens, compliant cartridge and disposable pen boxes, and a wide variety of child resistante packaging options.</p>

                    <!-- 社交媒体图标 -->
                    <div class="social-icons">
                        <SocialIcon href="https://www.facebook.com/profile.php?id=61584007651167" title="Facebook" icon="facebook"  />
                        <SocialIcon href="https://www.youtube.com/@LeaflyPackaging" title="YouTube" icon="youtube"  />
                        <SocialIcon href="https://www.linkedin.com/company/leaflypackaging" title="LinkedIn" icon="linkedin" />
                        <SocialIcon href="https://www.tiktok.com/@LeaflyPackaging" title="TikTok" icon="tiktok" />
                    </div>

                    <p class="copyright">Copyright © 2022 Leaflypackaging. All Rights Reserved.</p>
                </div>

                <!-- 右侧: 链接和联系方式 -->
                <div class="footer-right">
                    <div class="footer-grid">
                        <!-- 链接列表 -->
                        <template v-for="item in navItemList" :key="item.name">
                            <div class="footer-links">
                                <h3>{{ item.name }}</h3>
                                <ul>
                                    <li v-for="child in item.children" :key="child.id">
                                        <nuxt-link :to="child.linkUrl">{{ child.name }}</nuxt-link>
                                    </li>
                                </ul>
                            </div>
                        </template>

                        <!-- 联系方式 -->
                        <div class="footer-contact">
                            <h3>CONTACT US</h3>
                            <ContactItem icon="phone" label="PHONE NUMBER" value="(+86) 158 1559 7437" href="tel:+8613556842094" />
                            <ContactItem icon="email" label="EMAIL ADDRESS" value="sales@leaflypackaging.com" href="mailto:sales@leaflypackaging.com" />
                            <ContactItem icon="location" label="LOCATIONS" value="Baoan - Shenzhen - China." />

                            <!-- 二维码 -->
                            <div class="qr-codes">
                                <QrCode label="WeChat" src="/leaflypackaging-com/images/wechat-qr.webp" />
                                <QrCode label="WhatsApp" src="/leaflypackaging-com/images/whatsApp-qr.webp" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { NavItem } from '~/types';
import cmsUtils from '~/utils/cmsUtils'
import whatapp from '../common/whatapp.vue'
import SocialIcon from '../common/SocialIcon.vue'
import ContactItem from '../common/ContactItem.vue'
import QrCode from '../common/QrCode.vue'

const navItemList = ref<NavItem[]>([])
const cmsInfo = await cmsUtils.getCmsInfo()
navItemList.value = cmsUtils.getNavItemTreeByNavIndex("footer_main", cmsInfo)
</script>

<style scoped lang="scss">
.footer-content {
    display: flex;
    flex-direction: column;
    gap: 2rem;

    @media (min-width: 1024px) {
        flex-direction: row;
    }
}

.footer-left {
    width: 100%;
    padding: 2rem;
    background-color: #1f2937;
    border-radius: 0.5rem;
    margin-bottom: 2rem;

    @media (min-width: 1024px) {
        width: 25%;
        margin-bottom: 0;
    }
}

.footer-logo {
    height: 3.5rem;
    margin-bottom: 1.5rem;
}

.footer-desc {
    font-size: 0.875rem;
    line-height: 1.25rem;
    text-align: justify;
    color: #d1d5db;
    margin-bottom: 1.5rem;
}

.social-icons {
    display: flex;  
    margin-bottom: 1rem;
}
@media screen and (min-width:1280px) {
    .social-icons{
        gap: 1rem;
    }
}

.copyright {
    font-size: 0.75rem;
    color: #d1d5db;
}

.footer-right {
    width: 100%;

    @media (min-width: 1024px) {
        width: 75%;
        padding-left: 2rem;
    }
}

.footer-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0;

    @media (min-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
    }
}

.footer-links {
    padding: 1.5rem;

    & > div {
        border-bottom: 1px solid rgba(75, 85, 99, 0.3);

        @media (min-width: 1024px) {
            border-right: 1px solid rgba(75, 85, 99, 0.3);
            border-bottom: none;

            &:last-child {
                border-right: none;
            }
        }
    }
}

h3 {
    font-size: 0.875rem;
    font-weight: 600;
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-bottom: 1.5rem;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        bottom: -0.5rem;
        left: 0;
        width: 30px;
        height: 2px;
        background: linear-gradient(90deg, #10b981, #059669);
        border-radius: 1px;
    }
}

ul {
    list-style: none;
    padding: 0;
}

ul li {
    margin-bottom: 0.5rem;
}

ul li a {
    color: #d1d5db;
    text-decoration: none;
    font-size: 0.875rem;
    display: inline-flex;
    align-items: center;
    min-height: 32px;
    padding-top: 0.25rem;

    &:hover {
        color: #ffffff;
    }
}

.footer-contact {
    padding: 1.5rem;
}

.qr-codes {
    display: flex;
    gap: 0.75rem;
    margin-top: 1rem;
    justify-content: center;

    /* 小屏幕隐藏二维码 */
    @media (max-width: 1023px) {
        display: none;
    }
}
</style>
